import * as Model from '../../models/models';


export class PaymentSearchByStatementViewModel {

    policyholders:Array<Model.IPolicyholder>;
    billingstatementlogs: Array<Model.IBillingStatement>;
    billingstatementlogpaymentresponses: Array<Model.IBillingStatementLogPaymentResponse>;
    paymentRequests: Array<Model.IPaymentRequest>;
    paymentResponses: Array<Model.PaymentResponse>;
    isDataGridLoading: boolean;
    showNoSearchMatchMessage: boolean = false;
    searchResults:Array<PaymentSearchByStatementResult>;

}

export class PaymentSearchByStatementResult {

    organizationName: string;
    autoPay: boolean;
    currentDueDate: Date;
    billedAndUnpaidBalance: number;
    pastDueBalance: number;
    reasonCode: string;
    decisionTypeCode: string;
    paymentAmount:number;
    paymentType:string;
    billingAccountNumber: string;
    billingStatementLogid:string;
    merchantReferenceCode:string;
    paymentResponseId:string;
    

    public autoPayStatus = (): string => {

        if (this.autoPay) {
            return "ON";
        } else {
            return "OFF";
        }

    }
    
    
}